module.exports = __webpack_public_path__ + "img/mb_1.8bfb5ae5.jpg";